interface CsvColumn {
  header: string
  accessor: string | ((row: any, index?: number) => string | number | boolean)
}

export function convertToCsv(data: any[], columns: CsvColumn[]): string {
  const escape = (value: unknown): string => {
    const str = String(value ?? '')
    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
      return `"${str.replace(/"/g, '""')}"`
    }
    return str
  }

  const header = columns.map(col => escape(col.header)).join(',')
  const rows = data.map((row, index) =>
    columns
      .map(col => {
        const value =
          typeof col.accessor === 'function'
            ? col.accessor(row, index)
            : row[col.accessor]
        return escape(value)
      })
      .join(',')
  )

  return [header, ...rows].join('\n')
}

export function convertToJsonArray(
  data: any[],
  columns: CsvColumn[]
): Record<string, unknown>[] {
  return data.map((row, index) => {
    const obj: Record<string, unknown> = {}
    for (const col of columns) {
      obj[col.header] =
        typeof col.accessor === 'function'
          ? col.accessor(row, index)
          : row[col.accessor]
    }
    return obj
  })
}

export function downloadFile(
  content: string,
  filename: string,
  mimeType: string = 'text/csv;charset=utf-8;'
): void {
  const blob = new Blob([content], { type: mimeType })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export function getFilenameTimestamp(): string {
  const now = new Date()
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}`
}
